import { DateRangePicker } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import 'rsuite/dist/rsuite-no-reset.min.css';
import { CustomProvider } from "rsuite";
import * as locales from 'rsuite/locales';
import { axiosInstance } from "./axiosInstance";
import dayjs from 'dayjs';

const predefinedRanges = [
  {
    label: 'Hoy',
    value: [new Date(), new Date()],
    placement: 'left'
  },
  {
    label: 'Ayer',
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement: 'left'
  },
  {
    label: 'Semana pasada',
    value: [
          addDays(startOfWeek(new Date(), { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(new Date(), { weekStartsOn: 0 }), -7)
        ],
    placement: 'left'
  },
  {
    label: 'Esta semana',
    value: [startOfWeek(new Date()), endOfWeek(new Date())],
    placement: 'left'
  },
  {
    label: 'Últimos 7 días',
    value: [subDays(new Date(), 6), new Date()],
    placement: 'left'
  },
  {
    label: 'Últimos 30 días',
    value: [subDays(new Date(), 29), new Date()],
    placement: 'left'
  },
  {
    label: 'Este mes',
    value: [startOfMonth(new Date()), new Date()],
    placement: 'left'
  },
  {
    label: 'Mes pasado',
    value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
    placement: 'left'
  },
];

/**
 *
 * @returns {JSX.Element}
 * @constructor
 * Tiene rangos
 */

function IconCalendar(){
    return <i className="ki-outline ki-calendar-8 fs-1 me-2 text-gray-600"></i>
}

export default function Calendario({
   setActivity,
}) {

    const { allowedRange } = DateRangePicker;
    const maxDate = subDays(new Date(), 59);

    function changeRange(range){
        const desde = dayjs(range[0]).format('YYYY-MM-DD');
        const hasta = dayjs(range[1]).format('YYYY-MM-DD');

        axiosInstance.get(`/activity?fecha=${desde}&hasta=${hasta}`)
            .then(res => {
                if(Array.isArray(res.data)) setActivity(res.data);
            }).catch(err => console.log(err));
    }

  return (
      <>
        <style type={'text/css'}>
          {`
            
            .rs-picker-input-group .rs-input-group .rs-input-group-inside {
                background-color: var(--bs-light)!important;
                border-color: var(--bs-gray-100)!important;
                color: var(--bs-gray-700)!important;
                transition: color .2s ease!important;
            }
            
            .rs-input-group{
                border: none !important;
                background-color: var(--bs-light)!important;
                padding: 0.25rem!important;
            }
            
            #rangoFechas{
                background-color: var(--bs-light)!important;
            }
            
            .rs-input-group-addon{
                padding: 0!important;
            }
          `}
        </style>
              <CustomProvider locale={locales.esES}>
                  <DateRangePicker
                      id={'rangoFechas'}
                      ranges={predefinedRanges}
                      cleanable={false}
                      placement={'bottomEnd'}
                      format={'MMM dd, yyyy'}
                      label={<div className={'d-flex fs-base text-gray-600 fw-bold ms-2'}>Rango de fechas...</div>}
                      defaultValue={[new Date(), new Date()]}
                      caretAs={IconCalendar}
                      style={{ width: 170 }}
                      onShortcutClick={(shortcut) => {
                          changeRange(shortcut.value);
                      }}
                      onChange={value => changeRange(value)}
                      shouldDisableDate={allowedRange(maxDate, new Date())}
                  />
              </CustomProvider>
      </>
  );
}
